'use strict';

let config = {
  authRealm: 'Username-Password-Authentication',
  authGrantType: 'http://auth0.com/oauth/grant-type/password-realm'
};

// Settings configured here will be merged into the final config object.
export default Object.freeze(Object.assign({}, config));



// WEBPACK FOOTER //
// ./src/config/base.js